<template>
  <header class="main-header" :class="{ scrollable: burger }">
    <div class="content" :class="isScrolled && !loaded ? 'header-scrolled' : ''">
      <div class="flex al-center between mobile-version">
        <div class="burger pointer" :class="{ active: burger }" @click="toggleBurger">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <router-link
          :title="$fn.tr('home')"
          :to="`/${_.get(this.$store.state.main.indx, 'locale')}`"
        >
          <IconComponent name="headerLogo" v-if="locale === 'en'" />
          <IconComponentMobile name="headerLogo" v-if="locale === 'ge'" />
          <IconComponent name="mobile-logo" v-if="locale === 'en'" />
          <IconComponentMobile name="mobile-logo" v-if="locale === 'ge'" />
        </router-link>
        <div class="mobile-lang">
          <router-link
            tag="a"
            :to="_.get($store.state.main.selected_menu_locales, 'ge')"
            v-if="_.get($store.state.main, 'locale') === 'en'"
          >
            {{ $fn.tr('GEO') }}
          </router-link>
          <router-link
            tag="a"
            :to="_.get($store.state.main.selected_menu_locales, 'en')"
            v-if="_.get($store.state.main, 'locale') === 'ge'"
          >
            {{ $fn.tr('ENG') }}
          </router-link>
        </div>
      </div>
      <router-link :to="`/${_.get(this.$store.state.main.indx, 'locale')}/search`" class="mg-btwn">
        <div class="search-icon">
          <IconComponent class="search-icon" name="search" />
        </div>
        <p class="f-roman">{{ $fn.tr('search-button') }}</p>
      </router-link>
      <!-- <div
				class="search-section"
				v-click-outside="closeSearch"
				@click="showSearch()"
				:class="{ 'search-active': addClass }"
			>
				<IconComponent class="search-icon" name="search" />
				<input
					:placeholder="$fn.tr('Search')"
					v-model="search"
					type="text"
					@keyup.enter="searchRequers(search)"
				/>
				<span @click="searchRequers(search)">
					<IconComponent
						class="arrow-icon pointer"
						:class="{ 'search-active': addClass }"
						name="arrow-right"
					/>
				</span>

				<div class="search-option" :class="{ 'search-shown': addClass }">
					<template v-for="(item, index) in searchData">
						<div
							@click="closeBurger()"
							class="search-item pointer"
							:key="index"
							v-if="searchData.length"
						>
							<router-link
								tag="h3"
								class="text-overflow-hidden-3"
								:to="_.get(item, 'url')"
								v-html="item.val"
							></router-link>
						</div>
					</template>
					<div class="no-item" v-if="!searchData.length">
						<h3 class="font-16 f-bold">
							{{ $fn.tr('nothing found') }}
						</h3>
					</div>
				</div>
			</div> -->
      <div class="header-content" :class="{ active: burger }">
        <nav>
          <ul>
            <li v-for="(item, index) in makeMenuTree()" :key="index" @click="burger = false">
              <router-link
                :to="_.get(item, 'children[0].full_url') || item.full_url"
                tag="a"
                v-if="!_.includes(item.configs, 'hide-from-menu')"
                :class="{
                  active: _.get(item, 'id') == _.get($store.state.main, 'selected_menu.pid'),
                }"
                class="font-2"
              >
                {{ item.title }}
              </router-link>
            </li>
          </ul>
        </nav>
        <div class="lang">
          <router-link
            tag="a"
            :to="_.get($store.state.main.selected_menu_locales, 'ge')"
            :class="{ active: _.get($store.state.main, 'locale') === 'ge' }"
            >{{ $fn.tr('GEO') }}</router-link
          >
          /
          <router-link
            tag="a"
            :class="{ active: _.get($store.state.main, 'locale') === 'en' }"
            :to="_.get($store.state.main.selected_menu_locales, 'en')"
            >{{ $fn.tr('ENG') }}</router-link
          >
        </div>
        <div class="header-bottom">
          <div class="accessibility">
            <button :title="$fn.tr('accessibility')" @click="openAccessiblity" class="pointer">
              <IconComponent name="access-logo" />
            </button>

            <div
              class="accessiblity-menu"
              :class="{
                active: _.get($store.state.main, 'accessiblityModalActive'),
              }"
            >
              <div class="menu-header">
                <p class="font-16 ">
                  {{ $fn.tr('Accessibility Menu') }}
                </p>
                <button @click="closeAccessibility" class="pointer  close-btn">
                  <IconComponent name="close" />
                </button>
              </div>
              <div class="accessibility-content">
                <button class="reader single-element pointer" @click="screenReader()">
                  <IconComponent name="reader" />
                  <p>{{ $fn.tr('Screen reader') }}</p>
                </button>
                <button
                  class="contrast single-element pointer"
                  id="contrast"
                  @click="changeColor()"
                >
                  <IconComponent name="contrast" />
                  <p>{{ $fn.tr('Contrast +') }}</p>

                  <div class="contact-progress">
                    <span
                      v-if="
                        $store.state.main.changeColorContentState > 0 &&
                          $store.state.main.changeColorContentState != 4
                      "
                    ></span>
                    <span
                      v-if="
                        $store.state.main.changeColorContentState > 1 &&
                          $store.state.main.changeColorContentState != 4
                      "
                    ></span>
                    <span
                      v-if="
                        $store.state.main.changeColorContentState > 2 &&
                          $store.state.main.changeColorContentState != 4
                      "
                    ></span>
                  </div>
                </button>
                <button class="bigger-text single-element pointer" @click="increaseFontSize">
                  <IconComponent name="big-text" />
                  <p>{{ $fn.tr('Bigger Text') }}</p>
                  <div class="progress">
                    <span v-if="textState > 0"></span>
                    <span v-if="textState > 1"></span>
                    <span v-if="textState > 2"></span>
                    <span v-if="textState > 3"></span>
                  </div>
                </button>
                <button class="make-bold single-element pointer" @click="changeCase">
                  <IconComponent name="bold" />
                  <p>{{ $fn.tr('Make Bold') }}</p>
                </button>
              </div>
              <button class="reset-content pointer" @click="resetAll">
                <IconComponent name="reset" />
                <p>{{ $fn.tr('Reset All') }}</p>
              </button>
            </div>
          </div>
          <div class="share-content">
            <p class="font-16 ">{{ $fn.tr('Follow on us') }}</p>
            <div class="share-icons">
              <template v-for="(icon, index) in getShareLinks">
                <a
                  class="share-icon pointer"
                  :href="icon.url"
                  v-html="icon.svg"
                  :key="index"
                  target="_blank"
                  :title="icon.title"
                ></a>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import IconComponent from '../IconComponent.vue';
import IconComponentMobile from '../iconMobile.vue';
import Main from '@/mixins/main';

export default {
  mixins: [Main],
  components: {
    IconComponent,
    IconComponentMobile,
  },
  watch: {
    burger: {
      handler(val) {
        val
          ? (document.querySelector('html').style.overflow = 'hidden')
          : (document.querySelector('html').style.overflow = 'auto');
      },
    },
    '$store.state.main.changeColorContentState': {
      immediate: true,

      handler(val) {
        if (val == 1) {
          document.body.className = '';
          document.body.classList.add('white');
        } else if (val == 2) {
          document.body.className = '';
          document.body.classList.add('yellow');
        } else if (val == 3) {
          document.body.className = '';
          document.body.classList.add('black');
        } else if (val == 4) {
          document.body.className = '';
        }
      },
    },
    $route: {
      immediate: true,
      handler(val) {
        // console.log(val, 'route change');
        this.resetNotBg();
        if (val) {
          document.querySelector('html').style.overflow = 'auto';
        }
      },
    },

    // search: {
    // 	handler(val) {
    // 		if (val?.length > 3) {
    // 			this.searchRequers(val);
    // 		} else {
    // 			this.addClass = false;
    // 		}
    // 	},
    // },
  },
  data() {
    return {
      burger: false,
      addClass: false,
      accessiblity: false,
      textState: 0,
      contentState: 0,
      // search: null,
      // searchData: [],
      // finalRes: [],
      windowWidth: window.innerWidth,
      isScrolled: true,
      loaded: true,
      case: false,
    };
  },
  computed: {
    getMenus() {
      return _.get(this.$store.state.main.indx, 'menus');
    },
    locale() {
      return _.get(this.$store.state.main.indx, 'locale');
    },
    getShareLinks() {
      let socialList = [];

      let socialSvgs = _.get(this.$store.state.main.indx, 'widgets.social_follow');

      if (!socialSvgs) return socialList;
      for (let i in socialSvgs) {
        socialList.push({
          svg: socialSvgs[i].svg,
          title: socialSvgs[i].title,
          url: socialSvgs[i].url,
        });
      }

      return socialList;
    },
  },
  methods: {
    showSearch() {
      if (this.search?.length > 3) {
        this.addClass = true;
      }
    },
    screenReader() {
      let widget = _.get(this.$store.state.main.indx, 'widgets.screen_reader_link.screen-reader');

      this.$router.push(`/${_.get(this.$store, 'state.main.indx.locale')}/${widget}`);
    },
    closeSearch() {
      this.addClass = false;
    },
    openAccessiblity() {
      this.$store.commit('main/accessiblityModal');
    },
    closeAccessibility() {
      this.$store.commit('main/accessiblityModalClose');
    },
    toggleBurger() {
      this.burger = !this.burger;
      this.closeAccessibility();
    },
    closeBurger() {
      this.burger = false;
      this.search = '';
    },
    // search_in_menus(id) {
    // 	let menus = this.$store.state.main.indx.menus;
    // 	let _menu = {};
    // 	menus = menus.filter((menu) => menu.secondary_data);
    // 	for (let j = 0; j < menus.length; j++) {
    // 		let secondary_data = menus[j].secondary_data.filter(
    // 			(sec) => sec.page && sec.page.length !== 0
    // 		);
    // 		for (let k = 0; k < secondary_data.length; k++) {
    // 			if (secondary_data[k].page.includes(id) && secondary_data[k].page.length == 1) {
    // 				_menu.link = menus[j].full_url;
    // 				_menu.titles = menus[j].titles;
    // 				_menu.full = menus[j];
    // 			}
    // 		}
    // 	}

    // 	return _menu.link;
    // 	// this.$router.push(_menu.link);
    // },
    // async searchRequers(val) {
    // 	let menus = this.$store.state.main.indx.menus;
    // 	var finalRes = [];
    // 	this.addClass = true;

    // 	let formData = {};
    // 	formData.searchWord = val;
    // 	let tmp = await this.$fn.postData('main/search', formData);

    // 	for (let i in _.get(tmp, 'data.content')) {
    // 		tmp.data.content[i].url = this.search_in_menus(tmp.data.content[i].id);
    // 		if (!tmp.data.content[i].url)
    // 			tmp.data.content[i].url = this.$store.getters['main/getSingleUrl'](tmp.data.content[i]);
    // 	}

    // 	this.searchData = tmp.data.content;
    // 	this.searchData.forEach(function(item) {
    // 		let _menu = {};
    // 		menus = menus.filter((menu) => menu.secondary_data);
    // 		for (let j = 0; j < menus.length; j++) {
    // 			let secondary_data = menus[j].secondary_data.filter(
    // 				(sec) => sec.page && sec.page.length !== 0
    // 			);
    // 			for (let k = 0; k < secondary_data.length; k++) {
    // 				if (secondary_data[k].page.includes(item.id) && secondary_data[k].page.length == 1) {
    // 					_menu.link = menus[j].full_url;
    // 					_menu.titles = menus[j].titles;
    // 					_menu.full = menus[j];
    // 				}
    // 			}
    // 		}

    // 		if (_menu.link !== undefined) {
    // 			finalRes.push(item);
    // 		}
    // 	});
    // 	console.log(this.searchData, 'searchData');
    // 	// this.searchData = finalRes;
    // 	return true;
    // },
    handleScroll(event) {
      if (this.windowWidth < 768) {
        if (window.pageYOffset > 100) {
          this.isScrolled = true;
          this.loaded = false;
        } else {
          this.isScrolled = false;
        }
        return this.isScrolled;
      }
    },
    increaseFontSize(increase = true) {
      var tagDiv = document.getElementsByTagName('div');

      var tagSpan = document.getElementsByTagName('span');
      var tagA = document.getElementsByTagName('a');
      var tagH1 = document.getElementsByTagName('h1');
      var tagH2 = document.getElementsByTagName('h2');
      var tagH3 = document.getElementsByTagName('h3');
      var tagH4 = document.getElementsByTagName('h4');
      var tagP = document.getElementsByTagName('p');
      var tagLi = document.getElementsByTagName('li');

      this.textState++;

      if (this.textState <= 4) {
        tagSpan.forEach((item) => {
          let fontSize = parseFloat(
            window.getComputedStyle(item, null).getPropertyValue('font-size')
          );
          item.style.fontSize = increase ? fontSize + 2 + 'px' : fontSize - 2 + 'px';
        });
        tagA.forEach((item) => {
          let fontSize = parseFloat(
            window.getComputedStyle(item, null).getPropertyValue('font-size')
          );
          item.style.fontSize = increase ? fontSize + 2 + 'px' : fontSize - 2 + 'px';
        });
        tagH1.forEach((item) => {
          let fontSize = parseFloat(
            window.getComputedStyle(item, null).getPropertyValue('font-size')
          );
          item.style.fontSize = increase ? fontSize + 2 + 'px' : fontSize - 2 + 'px';
        });
        tagH2.forEach((item) => {
          let fontSize = parseFloat(
            window.getComputedStyle(item, null).getPropertyValue('font-size')
          );
          item.style.fontSize = increase ? fontSize + 2 + 'px' : fontSize - 2 + 'px';
        });
        tagH3.forEach((item) => {
          let fontSize = parseFloat(
            window.getComputedStyle(item, null).getPropertyValue('font-size')
          );
          item.style.fontSize = increase ? fontSize + 2 + 'px' : fontSize - 2 + 'px';
        });
        tagH4.forEach((item) => {
          let fontSize = parseFloat(
            window.getComputedStyle(item, null).getPropertyValue('font-size')
          );
          item.style.fontSize = increase ? fontSize + 2 + 'px' : fontSize - 2 + 'px';
        });
        tagP.forEach((item) => {
          let fontSize = parseFloat(
            window.getComputedStyle(item, null).getPropertyValue('font-size')
          );
          item.style.fontSize = increase ? fontSize + 2 + 'px' : fontSize - 2 + 'px';
        });
        tagLi.forEach((item) => {
          let fontSize = parseFloat(
            window.getComputedStyle(item, null).getPropertyValue('font-size')
          );
          item.style.fontSize = increase ? fontSize + 2 + 'px' : fontSize - 2 + 'px';
        });
      }
      if (this.textState > 4) {
        this.textState = 0;
        tagSpan.forEach((item) => {
          let fontSize = parseFloat(
            window.getComputedStyle(item, null).getPropertyValue('font-size')
          );
          item.style.fontSize = null;
        });
        tagA.forEach((item) => {
          let fontSize = parseFloat(
            window.getComputedStyle(item, null).getPropertyValue('font-size')
          );
          item.style.fontSize = null;
        });
        tagDiv.forEach((item) => {
          let fontSize = parseFloat(
            window.getComputedStyle(item, null).getPropertyValue('font-size')
          );
          item.style.fontSize = null;
        });
        tagH1.forEach((item) => {
          let fontSize = parseFloat(
            window.getComputedStyle(item, null).getPropertyValue('font-size')
          );
          item.style.fontSize = null;
        });
        tagH2.forEach((item) => {
          let fontSize = parseFloat(
            window.getComputedStyle(item, null).getPropertyValue('font-size')
          );
          item.style.fontSize = null;
        });
        tagH3.forEach((item) => {
          let fontSize = parseFloat(
            window.getComputedStyle(item, null).getPropertyValue('font-size')
          );
          item.style.fontSize = null;
        });
        tagH4.forEach((item) => {
          let fontSize = parseFloat(
            window.getComputedStyle(item, null).getPropertyValue('font-size')
          );
          item.style.fontSize = null;
        });
        tagP.forEach((item) => {
          let fontSize = parseFloat(
            window.getComputedStyle(item, null).getPropertyValue('font-size')
          );
          item.style.fontSize = null;
        });
        tagLi.forEach((item) => {
          let fontSize = parseFloat(
            window.getComputedStyle(item, null).getPropertyValue('font-size')
          );
          item.style.fontSize = null;
        });
      }
    },
    changeColor() {
      this.$store.commit('main/changeColor');
    },
    changeCase() {
      var tagSpan = document.getElementsByTagName('span');
      var tagA = document.getElementsByTagName('a');
      var tagDiv = document.getElementsByTagName('div');
      var tagH1 = document.getElementsByTagName('h1');
      var tagH2 = document.getElementsByTagName('h2');
      var tagH3 = document.getElementsByTagName('h3');
      var tagH4 = document.getElementsByTagName('h4');
      var tagP = document.getElementsByTagName('p');
      var tagLi = document.getElementsByTagName('li');

      this.case = !this.case;

      if (!this.case) {
        tagSpan.forEach((item) => {
          item.classList.add('f-bold');
        });
        tagA.forEach((item) => {
          item.classList.add('f-bold');
        });
        tagDiv.forEach((item) => {
          item.classList.add('f-bold');
        });
        tagH1.forEach((item) => {
          item.classList.add('f-bold');
        });
        tagH2.forEach((item) => {
          item.classList.add('f-bold');
        });
        tagH3.forEach((item) => {
          item.classList.add('f-bold');
        });
        tagH4.forEach((item) => {
          item.classList.add('f-bold');
        });
        tagP.forEach((item) => {
          item.classList.add('f-bold');
        });
        tagLi.forEach((item) => {
          item.classList.add('f-bold');
        });
      } else {
        tagSpan.forEach((item) => {
          item.classList.remove('f-bold');
        });
        tagA.forEach((item) => {
          item.classList.remove('f-bold');
        });
        tagDiv.forEach((item) => {
          item.classList.remove('f-bold');
        });
        tagH1.forEach((item) => {
          item.classList.remove('f-bold');
        });
        tagH2.forEach((item) => {
          item.classList.remove('f-bold');
        });
        tagH3.forEach((item) => {
          item.classList.remove('f-bold');
        });
        tagH4.forEach((item) => {
          item.classList.remove('f-bold');
        });
        tagP.forEach((item) => {
          item.classList.remove('f-bold');
        });
        tagLi.forEach((item) => {
          item.classList.remove('f-bold');
        });
      }
    },
    resetAll() {
      document.body.className = '';
      document.body.style = null;
      this.caseStatus = '';
      this.textState = 0;
      this.case = false;

      this.$store.commit('main/resetBackground');

      let root = document.getElementsByTagName('html')[0];

      root.removeAttribute('class', 'f-bold');
      var tagDiv = document.getElementsByTagName('div');

      var tagSpan = document.getElementsByTagName('span');
      var tagA = document.getElementsByTagName('a');
      var tagH1 = document.getElementsByTagName('h1');
      var tagH2 = document.getElementsByTagName('h2');
      var tagH3 = document.getElementsByTagName('h3');
      var tagH4 = document.getElementsByTagName('h4');
      var tagP = document.getElementsByTagName('p');
      var tagLi = document.getElementsByTagName('li');

      tagSpan.forEach((item) => {
        let fontSize = parseFloat(
          window.getComputedStyle(item, null).getPropertyValue('font-size')
        );
        item.style.fontSize = null;
        item.classList.remove('f-bold');
      });
      tagA.forEach((item) => {
        let fontSize = parseFloat(
          window.getComputedStyle(item, null).getPropertyValue('font-size')
        );
        item.style.fontSize = null;
        item.classList.remove('f-bold');
      });
      tagDiv.forEach((item) => {
        let fontSize = parseFloat(
          window.getComputedStyle(item, null).getPropertyValue('font-size')
        );
        item.style.fontSize = null;
        item.classList.remove('f-bold');
      });
      tagH1.forEach((item) => {
        let fontSize = parseFloat(
          window.getComputedStyle(item, null).getPropertyValue('font-size')
        );
        item.style.fontSize = null;
        item.classList.remove('f-bold');
      });
      tagH2.forEach((item) => {
        let fontSize = parseFloat(
          window.getComputedStyle(item, null).getPropertyValue('font-size')
        );
        item.style.fontSize = null;
        item.classList.remove('f-bold');
      });
      tagH3.forEach((item) => {
        let fontSize = parseFloat(
          window.getComputedStyle(item, null).getPropertyValue('font-size')
        );
        item.style.fontSize = null;
        item.classList.remove('f-bold');
      });
      tagH4.forEach((item) => {
        let fontSize = parseFloat(
          window.getComputedStyle(item, null).getPropertyValue('font-size')
        );
        item.style.fontSize = null;
        item.classList.remove('f-bold');
      });
      tagP.forEach((item) => {
        let fontSize = parseFloat(
          window.getComputedStyle(item, null).getPropertyValue('font-size')
        );
        item.style.fontSize = null;
        item.classList.remove('f-bold');
      });
      tagLi.forEach((item) => {
        let fontSize = parseFloat(
          window.getComputedStyle(item, null).getPropertyValue('font-size')
        );
        item.style.fontSize = null;
        item.classList.remove('f-bold');
      });
    },
    resetNotBg() {
      document.body.style = null;
      this.caseStatus = '';
      this.textState = 0;
      this.case = false;

      let root = document.getElementsByTagName('html')[0];

      root.removeAttribute('class', 'f-bold');
      var tagDiv = document.getElementsByTagName('div');

      var tagSpan = document.getElementsByTagName('span');
      var tagA = document.getElementsByTagName('a');
      var tagH1 = document.getElementsByTagName('h1');
      var tagH2 = document.getElementsByTagName('h2');
      var tagH3 = document.getElementsByTagName('h3');
      var tagH4 = document.getElementsByTagName('h4');
      var tagP = document.getElementsByTagName('p');
      var tagLi = document.getElementsByTagName('li');

      tagSpan.forEach((item) => {
        let fontSize = parseFloat(
          window.getComputedStyle(item, null).getPropertyValue('font-size')
        );
        item.style.fontSize = null;
        item.classList.remove('f-bold');
      });
      tagA.forEach((item) => {
        let fontSize = parseFloat(
          window.getComputedStyle(item, null).getPropertyValue('font-size')
        );
        item.style.fontSize = null;
        item.classList.remove('f-bold');
      });
      tagDiv.forEach((item) => {
        let fontSize = parseFloat(
          window.getComputedStyle(item, null).getPropertyValue('font-size')
        );
        item.style.fontSize = null;
        item.classList.remove('f-bold');
      });
      tagH1.forEach((item) => {
        let fontSize = parseFloat(
          window.getComputedStyle(item, null).getPropertyValue('font-size')
        );
        item.style.fontSize = null;
        item.classList.remove('f-bold');
      });
      tagH2.forEach((item) => {
        let fontSize = parseFloat(
          window.getComputedStyle(item, null).getPropertyValue('font-size')
        );
        item.style.fontSize = null;
        item.classList.remove('f-bold');
      });
      tagH3.forEach((item) => {
        let fontSize = parseFloat(
          window.getComputedStyle(item, null).getPropertyValue('font-size')
        );
        item.style.fontSize = null;
        item.classList.remove('f-bold');
      });
      tagH4.forEach((item) => {
        let fontSize = parseFloat(
          window.getComputedStyle(item, null).getPropertyValue('font-size')
        );
        item.style.fontSize = null;
        item.classList.remove('f-bold');
      });
      tagP.forEach((item) => {
        let fontSize = parseFloat(
          window.getComputedStyle(item, null).getPropertyValue('font-size')
        );
        item.style.fontSize = null;
        item.classList.remove('f-bold');
      });
      tagLi.forEach((item) => {
        let fontSize = parseFloat(
          window.getComputedStyle(item, null).getPropertyValue('font-size')
        );
        item.style.fontSize = null;
        item.classList.remove('f-bold');
      });
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll, { passive: true });
  },
};
</script>
<style lang="scss">
header {
  .lang {
    width: 100%;
    display: flex;
    // margin-top: 85px;
    color: var(--bonus-txt);
    // padding-left: 20px;
    @media (max-width: 1599px) {
    }
    @media (max-width: 1365px) {
    }
    @media (max-width: 767px) {
      display: none;
    }
    a {
      color: var(--bonus-txt);
      opacity: 1;
      margin: 0 3px 0 0;
      cursor: pointer;
      transition: 0.3s ease-in-out;
      &.active {
        color: var(--bonus-txt);
        opacity: 0.7;
        transition: 0.3s ease-in-out;
        cursor: default;
      }
      // &:hover {
      //   color: var(--bonus-txt);
      //   transition: 0.3s ease-in-out;
      //   opacity: 1;
      // }
      &:last-child {
        margin: 0 3px 0 3px;
      }
    }
  }
  left: 0;
  z-index: 99;
  width: 360px;
  height: 100vh;
  position: fixed;
  background: var(--white-bg);
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 1px;
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    width: 1px;
    background: transparent;
  }
  &::-webkit-scrollbar-track {
    width: 1px;
    background: transparent;
  }
  @media (max-width: 1599px) {
    width: 265px;
  }
  @media (max-width: 1439px) {
    width: 251px;
  }
  @media (max-width: 1365px) {
    width: 246px;
  }
  @media (max-width: 1023px) {
    width: 241px;
  }
  @media (max-width: 767px) {
    top: 0;
    left: 0;
    width: 100%;
    z-index: 999;
    height: auto;
    position: fixed;
    overflow-y: hidden;
    background: var(--white-bg);
    &.scrollable {
      overflow-y: auto;
    }
  }
  .content {
    padding: 54px 52px 55px;
    display: flex;
    flex-direction: column;
    height: 100%;
    transition: 0.4s ease-in-out;
    @media (max-width: 1599px) {
      padding: 54px 21px 34px;
    }
    @media (max-width: 1439px) {
      padding: 34px 21px;
    }
    @media (max-height: 699px) {
      padding: 34px 21px;
    }
    @media (max-width: 767px) {
      padding: 29px 20px;
      &.header-scrolled {
        padding: 15px 20px;
        transition: 0.4s ease-in-out;
        .search-section {
          height: 0;
          margin: 0;
          opacity: 0;
          pointer-events: none;
          transition: opacity 0.2s ease-in-out, height 0.4s ease-in-out 0.2s,
            margin 0.4s ease-in-out 0.2s;
        }
        .header-content {
          top: 116px !important;
          height: calc(100vh - 116px) !important;
        }
      }
    }
    .burger {
      display: none;
      @media (max-width: 767px) {
        width: 22px;
        height: 18px;
        display: block;
        position: relative;
      }
      span {
        width: 22px;
        height: 4px;
        display: block;
        border-radius: 2px;
        transition: 0.4s ease-out;
        background: var(--bonus-txt);
        &:nth-child(2) {
          transition: 0.1s ease-in-out;
        }
        &:not(:last-child) {
          margin-bottom: 3px;
        }
      }
      &.active {
        span:nth-child(1) {
          top: 50%;
          position: absolute;
          transform: rotate(45deg);
          transition: 0.4s ease-out;
        }
        span:nth-child(3) {
          top: 50%;
          position: absolute;
          transform: rotate(-45deg);
          transition: 0.4s ease-out;
        }
        span:nth-child(2) {
          opacity: 0;
          visibility: hidden;
        }
      }
    }
    .headerLogo {
      margin-left: 28px;
      @media (max-width: 767px) {
        display: none;
      }
    }
    .mobile-lang {
      display: none;
      a {
        color: var(--bonus-txt);
      }
      @media (max-width: 767px) {
        display: block;
      }
    }
    .mobile-logo {
      display: none;
      @media (max-width: 767px) {
        display: flex;
        justify-content: center;
      }
    }
    // .search-section {
    // 	width: 100%;
    // 	height: 40px;
    // 	position: relative;
    // 	margin: 42px 0 72px;
    // 	background: transparent;
    // 	border: 1px solid var(--bonus-txt3);
    // 	transition: opacity 0.4s ease-in-out 0.4s, height 0.2s ease-in-out, margin 0.2s ease-in-out;
    // 	// &.search-active {
    // 	//   background: var(--searchBg);
    // 	//   transition: 0.4s ease-in-out;
    // 	//   input {
    // 	//     background: var(--searchBg);
    // 	//     transition: 0.4s ease-in-out;
    // 	//   }
    // 	// }
    // 	@media (max-width: 1599px) {
    // 		margin: 34px 0;
    // 	}
    // 	@media (max-width: 767px) {
    // 		margin: 30px 0 0;
    // 	}
    // 	.search-icon {
    // 		top: 50%;
    // 		left: 19px;
    // 		display: flex;
    // 		position: absolute;
    // 		align-items: center;
    // 		justify-content: center;
    // 		transition: 0.2s ease-in-out;
    // 		transform: translate(0, -50%);
    // 		svg {
    // 			// fill: var(--bonus-txt3);
    // 			fill: var(--search-border);
    // 			transition: 0.2s ease-in-out;
    // 			path {
    // 				transition: 0.2s ease-in-out;
    // 				// fill: var(--bonus-txt3) !important;
    // 				fill: var(--search-border) !important;
    // 			}
    // 		}
    // 	}
    // 	.arrow-icon {
    // 		top: 50%;
    // 		right: 17px;
    // 		display: flex;
    // 		position: absolute;
    // 		align-items: center;
    // 		justify-content: center;
    // 		transition: 0.4s ease-in-out;
    // 		transform: translate(0, -50%) rotate(0);
    // 		svg {
    // 			transition: 0.2s ease-in-out;
    // 			fill: var(--secondarty-arrow);
    // 			path {
    // 				transition: 0.2s ease-in-out;
    // 				fill: var(--secondarty-arrow) !important;
    // 			}
    // 		}
    // 	}
    // 	.search-active {
    // 		transform: translate(0, -50%) rotate(90deg);
    // 		transition: 0.4s ease-in-out;
    // 	}
    // 	input {
    // 		padding: 0 35px 0 60px;
    // 		width: -webkit-fill-available;
    // 		height: 40px;
    // 		font-size: 16px;
    // 		background: transparent;
    // 		// color: var(--bonus-txt3);
    // 		color: var(--bonus-txt);
    // 		font-family: 'Helvetica-Roman';
    // 		outline: none;
    // 		border: none;
    // 		// background-color: var(--primay-button-bg);
    // 		border: 1px solid var(--search-border);
    // 		transition: 0.4s ease-in-out;
    // 		&::placeholder {
    // 			color: var(--bonus-txt);
    // 			font-family: 'Helvetica-Roman';
    // 		}
    // 	}
    // 	.search-option {
    // 		position: relative;
    // 		z-index: 999;
    // 		background: var(--search-bg);
    // 		padding: 20px 20px 30px;
    // 		transition: 0.4s ease-in-out;
    // 		opacity: 0;
    // 		visibility: hidden;
    // 		pointer-events: none;
    // 		overflow-y: auto;
    // 		max-height: 50vh;
    // 		@media (max-width: 1023px) {
    // 			z-index: 9999;
    // 		}
    // 		&::-webkit-scrollbar {
    // 			width: 5px;
    // 			background: transparent;
    // 		}
    // 		&::-webkit-scrollbar-thumb {
    // 			width: 5px;
    // 			background: var(--primary);
    // 			border-radius: 6px;
    // 			cursor: pointer;
    // 		}
    // 		&::-webkit-scrollbar-track {
    // 			width: 2px;
    // 			background: var(--border);
    // 		}
    // 		&.search-shown {
    // 			transition: 0.4s ease-in-out;
    // 			opacity: 1;
    // 			visibility: visible;
    // 			pointer-events: all;
    // 			@media (max-width: 767px) {
    // 				position: fixed;
    // 				width: calc(100% - 42px);
    // 			}
    // 		}
    // 		.no-item {
    // 			text-align: center;
    // 			h3 {
    // 				color: var(--bonus-txt);
    // 				line-height: 20px;
    // 				transition: 0.4s ease-in-out;
    // 			}
    // 		}
    // 		.search-item {
    // 			&:not(:last-child) {
    // 				padding-bottom: 16px;
    // 				margin-bottom: 20px;
    // 				border-bottom: 1px solid var(--border);
    // 			}
    // 			h3 {
    // 				color: var(--bonus-txt);
    // 				line-height: 20px;
    // 				margin-bottom: 11px;
    // 				transition: 0.4s ease-in-out;
    // 			}
    // 			span {
    // 				background: var(--secondary);
    // 				transition: 0.4s ease-in-out;
    // 			}

    // 			a {
    // 				color: var(--primary-txt);
    // 				line-height: 16px;
    // 				text-decoration: underline;
    // 			}
    // 		}
    // 	}
    // }
    .header-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: column;
      height: 100%;
      padding-left: 60px;
      padding-bottom: 60px;
      @media (max-width: 1599px) {
        padding-left: 20px;
      }
      @media (max-width: 767px) {
        position: fixed;
        top: 214px;
        left: 0;
        height: calc(100vh - 214px);
        width: 100%;
        padding: 20px 0 144px;
        background: var(--white-bg);
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
        transition: 0.4s ease-in-out;
        z-index: 999;
        overflow-y: scroll;
        &.active {
          opacity: 1;
          margin-top: 5px;
          position: unset;
          visibility: visible;
          pointer-events: all;
          transition: 0.4s ease-in-out;
        }
      }
      nav {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @media (max-width: 1599px) {
          padding-left: 0;
        }
        ul {
          list-style: none;
          @media (max-width: 767px) {
            padding-left: 0;
          }
          li:not(:last-child) {
            margin-bottom: 26px;
            @media (max-width: 1439px) {
              margin-bottom: 15px;
            }
            @media (max-height: 799px) {
              margin-bottom: 15px;
            }
          }
          li {
            position: relative;
            &.active::before {
              content: '';
              position: absolute;
              left: -20px;
              top: 0;
              width: 3px;
              height: 100%;
              z-index: 1;
              background: var(--primary-txt);
            }
            a {
              color: var(--bonus-txt);
              // text-transform: capitalize;
              transition: 0.4s ease-in;
              &:hover {
                color: var(--primary-txt);
                transition: 0.4s ease-out;
              }
              &.active {
                color: var(--primary-txt);
                transition: 0.4s ease-out;
                position: relative;
                // overflow: visible;
                -webkit-line-clamp: 2;
                &::before {
                  content: '';
                  width: 2px;
                  height: 17px;
                  background: var(--primary-txt);
                  position: absolute;
                  left: -20px;
                  top: 50%;
                  transform: translateY(-50%);
                }
              }
              @media (max-width: 1439px) {
                font-size: 16px;
              }
              @media (max-height: 799px) {
                font-size: 16px;
              }
              @media (max-width: 767px) {
                font-size: 21px;
              }
            }
            @media (max-width: 767px) {
              text-align: center;
            }
          }
        }
      }
      .header-bottom {
        width: 100%;
        justify-content: center;
        margin-top: 30px;
        @media (max-width: 1599px) {
          justify-content: flex-start;
        }
        @media (max-width: 1439px) {
          justify-content: space-between;
          display: flex;
          align-items: center;
          flex-direction: row-reverse;
        }
        @media (max-width: 1365px) {
          display: grid;
          justify-content: flex-start;
        }
        @media (max-width: 767px) {
          width: 100%;
          justify-content: center;
          .access-logo {
            margin: 0 auto;
          }
        }
        .accessibility {
          position: relative;
          @media (max-width: 767px) {
            display: flex;
            align-items: center;
            justify-content: center;
          }
          button {
            background: transparent;
          }
          .accessiblity-menu {
            width: 100%;
            position: absolute;
            top: 0%;
            left: 35%;
            transform: translate(-50%, -50%);
            background: var(--white-bg);
            width: 328px;
            opacity: 0;
            visibility: hidden;
            pointer-events: none;
            transition: 0.4s ease-in-out;
            box-shadow: 0px 0px 20px 1px rgba(0, 0, 0, 0.1);
            &.active {
              opacity: 1;
              visibility: visible;
              pointer-events: all;
              transition: 0.4s ease-in-out;
            }
            @media (max-width: 1599px) {
              transform: translate(-50%, -55%);
              left: 45%;
              width: 240px;
            }
            @media (max-width: 1439px) {
              top: -100%;
              left: -100%;
              width: 240px;
            }
            @media (max-width: 1365px) {
              top: 50%;
              left: 90%;
              width: 230px;
            }
            @media (max-width: 1365px) {
              left: 85%;
            }
            @media (max-width: 767px) {
              top: 50%;
              left: 50%;
              width: 300px;
            }
            .menu-header {
              background: var(--access-bg);
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 10px 20px;
              margin-bottom: 20px;
              border: 1px solid var(--bonus);
              .close-btn {
                background: transparent;
              }
              p {
                color: var(--white-txt);
              }
            }
            .accessibility-content {
              display: flex;
              flex-wrap: wrap;
              .single-element {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                width: calc(50% - 2px);
                background: transparent;
                min-height: 90px;
                border: 1px solid var(--border);
                position: relative;
                p {
                  color: var(--bonus-txt);
                  text-align: center;
                }
              }
              .contact-progress {
                width: 100%;
                display: flex;
                position: absolute;
                bottom: 0;
                span {
                  display: block;
                  height: 2px;
                  width: 33%;
                  background: var(--bonus-txt);
                  margin-right: 2px;
                }
              }
              .progress {
                width: 100%;
                display: flex;
                position: absolute;
                bottom: 0;
                span {
                  display: block;
                  height: 2px;
                  width: 25%;
                  background: var(--bonus-txt);
                  margin-right: 2px;
                }
              }
            }
            .reset-content {
              display: flex;
              align-items: center;
              justify-content: center;
              border: 1px solid var(--border);
              border-top: none;
              padding: 10px 0;
              width: 100%;
              background: transparent;
              p {
                color: var(--bonus-txt);
                margin-left: 5px;
              }
            }
          }
        }
        .share-content {
          // margin-top: 55px;
          margin-top: 1vw;
          @media (max-width: 1599px) {
            margin-top: 34px;
          }
          @media (max-width: 1439px) {
            margin-top: 0;
          }
          @media (max-width: 1365px) {
            margin-top: 34px;
          }
          p {
            color: var(--bonus-txt);
            margin-bottom: 17px;
            transition: 0.4s ease-in-out;
          }
          .share-icons {
            display: flex;
            align-items: center;
            width: 100%;
            @media (max-width: 767px) {
              justify-content: center;
            }
            .share-icon:not(:last-child) {
              margin-right: 10px;
            }
          }
        }
      }
    }
    .mobile-version {
      padding: 0 15px;
    }
  }
  .mg-btwn {
    height: 40px;
    position: relative;
    margin: 42px 20px 72px;
    padding: 20px 0 20px 50px;
    border-bottom: 1px solid var(--primary);
    @media (max-width: 1599px) {
      margin: 34px 20px;
    }
    @media (max-width: 767px) {
      margin: 30px 20px 0;
    }
    p {
      top: 50%;
      left: 50px;
      display: flex;
      position: absolute;
      align-items: center;
      color: var(--bonus-txt);
      justify-content: center;
      transition: 0.2s ease-in-out;
      transform: translate(0, -50%);
    }
    .search-icon {
      top: 50%;
      left: 10px;
      display: flex;
      position: absolute;
      align-items: center;
      justify-content: center;
      transition: 0.2s ease-in-out;
      transform: translate(0, -50%);
      svg {
        fill: var(--bonus-txt3);
        fill: var(--search-border);
        transition: 0.2s ease-in-out;
        path {
          transition: 0.2s ease-in-out;
          fill: var(--bonus-txt3) !important;
          fill: var(--search-border) !important;
        }
      }
    }
  }
}
</style>
